import React, { useEffect, useState } from "react";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import Footer from "../../../Kryzen Alpha App/Components/Footer/footer";
import DynamicFilterSelect from "../../../Kryzen Alpha App/Components/layouts/filter.select";
import HydroponicInventoryTable from "./Hydroponic Material Planning/hydroponic_inventory";
import { MdOutlineInventory } from "react-icons/md";
import { roundOffCost } from "../../Components/Functions/amt.fun";
import ButtonWithSVG from "../../Components/layouts/button_with_svg";
import { useDispatch, useSelector } from "react-redux";
import DynamicFilterInput from "../../Components/layouts/filter.inpit";
import getFilteredURL from "../../Components/Functions/filters.getUrl";
import Pagination from "../../Components/layouts/pagination";
import { setMaterialInventoryPage } from "../../redux/Pagination/pagination"

const HydroponicInventory = () => {
  const [refresh, setRefresh] = useState(false);
  const dispatch = useDispatch();
    const page = useSelector((state) => state.pagination.materialInventoryPage);
  const [data, setData] = useState();
  const [filters, setFilters] = useState({
    hydroponicType: "",
    item: "",
    size: "",
  });
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalAmount, setTotalAmount] = useState(0);
  const debouncedFilters = useDebounce(filters, 400);

  const handleTotalAmount = (amount) => {
    setTotalAmount(amount);
  };
  const store = useSelector((store) => store.login.user);

  useEffect(() => {
    performRequest(
      "GET",
      getFilteredURL(
        "/materialPlanning/getAllMaterialList",
        page,
        debouncedFilters
      )
    )
      .then((res) => {
        if (res.status === 200) {
          // console.log("the data is", res.data);
          setData(res?.data);
          setTotalPages(Math.ceil(res?.data?.MaterialListCount / 50));
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [refresh, page, debouncedFilters]);

  function useDebounce(value, delay = 400) {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
      const handler = setTimeout(() => setDebouncedValue(value), delay);
      return () => clearTimeout(handler);
    }, [value, delay]);

    return debouncedValue;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none mb-4">
            <div className="row align-items-center">
              <div className="col-md-7">
                <h2 className="page-title mb-1">
                  <MdOutlineInventory
                    className="fs-2 me-1"
                    style={{ color: "green" }}
                  />{" "}
                  Material Inventory
                </h2>
                <h4 className="text-muted">Manage your inventory.</h4>
              </div>
              <div className="col-md-3 text-md-end">
                <h2 className="m-auto">
                  Total Stock Value :{" "}
                  <span className="text-success">
                    {roundOffCost(totalAmount)}
                  </span>
                </h2>
              </div>

              <div className="col-md-2 text-md-end">
                <ButtonWithSVG
                  href={"/hydroponic-material-inventory/new"}
                  buttonText="New inventory"
                  svg={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="icon"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      stroke="currentColor"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M12 5l0 14" />
                      <path d="M5 12l14 0" />
                    </svg>
                  }
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="card p-2">
                <div
                  id="faq-1"
                  className="accordion"
                  role="tablist"
                  aria-multiselectable="true"
                >
                  <div>
                    <div className="accordion-header m-0" role="tab">
                      <button
                        className="accordion-button fs-3 d-md-none p-0"
                        data-bs-toggle="collapse"
                        data-bs-target="#faq-1-1"
                      >
                        <h3 className="m-1">Filter result</h3>
                      </button>
                    </div>

                    <div
                      id="faq-1-1"
                      className="accordion-collapse collapse d-md-none"
                      role="tabpanel"
                      data-bs-parent="#faq-1"
                    >
                      <div className="accordion-body pt-0">
                        <div className="row">
                          <div className="col-12">
                            <DynamicFilterSelect
                              label="Hydroponic Type:"
                              value={filters.hydroponicType}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  hydroponicType: e.target.value,
                                })
                              }
                              type="text"
                            >
                              <option value="">Select</option>
                              <option value="flatbed">Flatbed</option>
                              <option value="growbags">Growbags</option>
                              <option value="foggers">Foggers</option>
                              <option value="cea">CEA</option>
                              <option value="planters">100 Planter</option>
                              <option value="dutch_bucket">Dutch Bucket</option>
                              <option value="sikit">Si Kit</option>
                              <option value="officeItems">Office Items</option>
                              <option value="tools">Tools And Machinery</option>
                              <option value="adiAcc">
                                Additional Accessories
                              </option>
                              <option value="fertilizer_self_consumption">
                              Fertilizes / Self Consumption
                            </option>
                            </DynamicFilterSelect>
                          </div>

                          <div className="col-12">
                            <DynamicFilterSelect
                              label="Select Size:"
                              value={filters.size}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  size: e.target.value,
                                })
                              }
                              type="text"
                            >
                              <option value="">Select</option>
                              <option value="Small">200g - 1kg (Small)</option>
                              <option value="Medium">
                                1kg - 10kg (Medium)
                              </option>
                              <option value="Large">10kg - 20kg (Large)</option>
                              <option value="Extra Large">
                                20kg - 50kg (Extra Large)
                              </option>
                              <option value="Double Extra Large">
                                50kg - 100kg (Double Extra Large)
                              </option>
                              <option value="Other">Other</option>
                            </DynamicFilterSelect>
                          </div>

                          <div className="col-12">
                            <DynamicFilterInput
                              label="Search Name:"
                              value={filters.item}
                              onChange={(e) =>
                                // setFilters({
                                //   ...filters,
                                //   item: e.target.value,
                                // })
                                setFilters((prev) => ({
                                  ...prev,
                                  item: e.target.value,
                                }))
                              }
                              placeholder="Search name..."
                            />
                          </div>

                          <div className="col-12 mt-2">
                            <div className="row">
                              <div className="col-6">
                                <button
                                  onClick={() => {
                                    setRefresh(!refresh);
                                    dispatch(setMaterialInventoryPage(1));
                                  }}
                                  className="btn btn-success w-100"
                                >
                                  Apply Filter
                                </button>
                              </div>
                              <div className="col-6">
                                <button
                                  onClick={() => {
                                    setFilters({
                                      hydroponicType: "",
                                      item: "",
                                      size: "",
                                    });
                                    setRefresh(!refresh);
                                  }}
                                  className="btn btn-secondary w-100"
                                >
                                  Reset Filter
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-body d-none d-md-block p-1 pt-0">
                      <div className="d-flex align-items-center flex-wrap gap-6">
                        <div className="col-md-2">
                          <DynamicFilterSelect
                            label="Hydroponic Type:"
                            value={filters.hydroponicType}
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                hydroponicType: e.target.value,
                              })
                            }
                            type="text"
                          >
                            <option value="">Select</option>
                            <option value="flatbed">Flatbed</option>
                            <option value="growbags">Growbags</option>
                            <option value="foggers">Foggers</option>
                            <option value="cea">CEA</option>
                            <option value="planters">100 Planter</option>
                            <option value="dutch_bucket">Dutch Bucket</option>
                            <option value="sikit">Si Kit</option>
                            <option value="officeItems">Office Items</option>
                            <option value="tools">Tools And Machinery</option>
                            <option value="adiAcc">
                              Additional Accessories
                            </option>
                            <option value="fertilizer_self_consumption">
                              Fertilizers / Self Consumption
                            </option>
                          </DynamicFilterSelect>
                        </div>

                        <div className="col-md-2">
                          <DynamicFilterSelect
                            label="Select Size:"
                            value={filters.size}
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                size: e.target.value,
                              })
                            }
                            type="text"
                          >
                            <option value="">Select</option>
                            <option value="Small">200g - 1kg (Small)</option>
                            <option value="Medium">1kg - 10kg (Medium)</option>
                            <option value="Large">10kg - 20kg (Large)</option>
                            <option value="Extra Large">
                              20kg - 50kg (Extra Large)
                            </option>
                            <option value="Double Extra Large">
                              50kg - 100kg (Double Extra Large)
                            </option>
                            <option value="Other">Other</option>
                          </DynamicFilterSelect>
                        </div>

                        <div className="col-md-3">
                          <DynamicFilterInput
                            label="Search Name:"
                            value={filters.item}
                            onChange={(e) =>
                              // setFilters({
                              //   ...filters,
                              //   item: e.target.value,
                              // })
                              setFilters((prev) => ({
                                ...prev,
                                item: e.target.value,
                              }))
                            }
                            placeholder="Search name..."
                          />
                        </div>

                        <div className="col-md-3">
                          <div className="row">
                            <div className="col-6">
                              <button
                                onClick={() => {
                                  setRefresh(!refresh);
                                  dispatch(setMaterialInventoryPage(1));
                                }}
                                className="btn btn-success w-100"
                              >
                                Apply Filter
                              </button>
                            </div>
                            <div className="col-6">
                              <button
                                onClick={() => {
                                  setFilters({
                                    hydroponicType: "",
                                    item: "",
                                    size: "",
                                  });
                                  setRefresh(!refresh);
                                }}
                                className="btn btn-secondary w-100"
                              >
                                Reset Filter
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-12 py-2">
              <div className="card">
                <HydroponicInventoryTable
                  refresh={refresh}
                  setRefresh={setRefresh}
                  data={data?.MaterialList}
                  onTotalAmountChange={handleTotalAmount}
                  currentPage={page}
                  itemsPerPage={50}
                />

                <Pagination
                  page={page}
                  setPage={(newPage) => dispatch(setMaterialInventoryPage(newPage))}
                  totalPages={totalPages}
                  pageDatalength={data?.MaterialList?.length}
                  showPage={showPage}
                  setShowPage={setShowPage}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default HydroponicInventory;
